module.exports = __webpack_public_path__ + "img/عنب-صورة.48ce7499.png";